<template>
    <div>
        <vs-row id="ratingWrapper">
            <vs-col class="w-full">
                <vs-table
                    search
                    :data="resources"
                    :no-data-text="loading ? 'Changement en cours...' : 'Aucun élément disponible'"
                    class="rating-table"
                    :expanded="expandedChange"
                >
                    <template slot="header">
                        <slot />
                        <vs-checkbox
                            v-model="expandAll"
                            name="checkboxExpandAll"
                        >
                            Afficher tous les commentaires saisis
                        </vs-checkbox>
                    </template>

                    <template slot="thead">
                        <vs-th></vs-th>
                        <vs-th :sort-key="col1.value">{{ col1.label }}</vs-th>
                        <vs-th :sort-key="col2.value">{{ col2.label }}</vs-th>
                        <vs-th :sort-key="col3.value" v-if="col3">{{ col3.label }}</vs-th>
                        <vs-th v-for="(param, i) in ratingParams" :key="i">
                            {{ param.label }}
                        </vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <template v-for="(item, i) in data">
                            <vs-tr :data="item" :class="[(item.multiple || item.is_deleted) ? 'prefilled': '']" :data-uid="item.uid">
                                <template v-if="(!item.is_deleted || showDeleted) && (!item.is_hidden || showHidden)">
                                    <vs-td>
                                        <feather-icon v-if="expanded[item.uid]" icon="ChevronDownIcon" class="expand-icon" @click="clickExpandHandle(item)" title="Cliquer pour enrouler"/>
                                        <feather-icon v-else icon="ChevronRightIcon" class="expand-icon" @click="clickExpandHandle(item)" title="Cliquer pour dérouler"/>
                                    </vs-td>
                                    <vs-td>
                                        <template v-if="col1.chip">
                                            <vx-tooltip v-if="col1 && col1.title" :text="item[col1.title]" position="top">
                                                <ms-chip :color="item[col1.chipColor]">
                                                    <b>{{ item[col1.value] }}</b>
                                                </ms-chip>
                                            </vx-tooltip>
                                            <ms-chip v-else-if="col1" :color="item[col1.chipColor]">
                                                <b>{{ item[col1.value] }}</b>
                                            </ms-chip>
                                        </template>
                                        <template v-else>
                                            <vx-tooltip v-if="col1 && col1.title" :text="item[col1.title]" position="top" v-html="item[col1.value]"></vx-tooltip>
                                            <span v-else-if="col1" v-html="item[col1.value]"></span>
                                        </template>
                                    </vs-td>
                                    <vs-td>
                                        <vx-tooltip v-if="col2 &&col2.title" :text="item[col2.title]" position="top" v-html="item[col2.value]"></vx-tooltip>
                                        <span v-else-if="col2" v-html="item[col2.value]"></span>
                                    </vs-td>
                                    <vs-td v-if="col3">
                                        <vx-tooltip v-if="col3 && col3.title" :text="item[col3.title]" position="top" v-html="item[col3.value]"></vx-tooltip>
                                        <span v-else-if="col3" v-html="item[col3.value]" @click="clickExpandHandle(item)"></span>
                                    </vs-td>
                                    <vs-td v-for="(param, index) in ratingParams" :key="`os-tenant-${i}-level-${index + 1}`" class="center">
                                        <vs-radio
                                            :id="`${name}-level-${param.id}_${item.uid}`"
                                            :key="item.uid"
                                            v-model="item.level"
                                            v-tooltip="(item.level == index + 1) ? item.message : getParamDescription(item, param)"
                                            :vs-name="item.uid"
                                            :color="item.to_validate ? 'warning' : 'primary'"
                                            :data-occskillid="item.id"
                                            :vs-value="parseFloat(param.id)"
                                            :disabled="typeForm === 'validation' || typeForm === 'consultation' || item.is_deleted"
                                            @input="inputNotationHandle(item.uid)"
                                        />
                                        <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                            <span v-if="item.has_personal_other_level && item.personal_other_level == parseFloat(param.id)" class="other_level_type_0">|</span>
                                            <span v-if="item.has_external_other_level && item.external_other_level == parseFloat(param.id)" class="other_level_type_1">|</span>
                                            <span v-if="item.has_second_external_other_level && item.second_external_other_level == parseFloat(param.id)" class="other_level_type_2">|</span>
                                        </label>
                                    </vs-td>
                                    <vs-td>
                                        {{ item.is_multiple ? 'Multiple' : ''}}
                                        {{ item.is_deleted  ? 'Supprimé' : ''}}
                                        {{ item.is_updated ? 'Mise à jour' : '' }}
                                        
                                        <template v-if="item.to_validate">
                                            <vs-button 
                                                size="small" 
                                                type="border" 
                                                icon-pack="feather" 
                                                icon="icon-check-square"
                                                v-tooltip="`Valider cet élément`"
                                                @click="inputNotationHandle(item.uid)"
                                            ></vs-button>
                                        </template>

                                    </vs-td>
                                </template>
                            </vs-tr>

                            <vs-tr v-if="expanded[item.uid] && (!item.is_deleted || showDeleted) && (!item.is_hidden || showHidden)">
                                <vs-td colspan="8">
                                    <textarea 
                                        :value="item.comment" 
                                        class="vs-textarea" 
                                        label="Commentaire" 
                                        @input="debouncedInputHandleComment($event.target.value, item)"
                                    />
                                </vs-td>
                            </vs-tr>
                        </template>

                    </template>
                </vs-table>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        name: {
            type: String,
            required: true
        },
        typeForm: {
            type: String,
            required: true
        },
        value: {
            type: Array,
            required: true
        },
        col1: {
            type: Object,
            required: true
        },
        col2: {
            type: Object,
            required: true
        },
        col3: {
            type: Object,
            require: false
        },
        showDeleted: {
            type: Boolean,
            required: false,
            default: false
        },
        showHidden: {
            type: Boolean,
            require: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        skillReview: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            log: console.log,
            resources: [],
            expanded: {},
            expandedChange: 0,
            expandAll: false,
            skills: [],
            debouncedInputHandleComment: _.debounce((value, item) => {
                this.inputHandleComment(value, item);
            }, 800)
        };
    },
    created() {
        if (this.loading) {
            setTimeout(() => {
                if(document.getElementById('ratingWrapper') && this.loading) {
                    this.$vs.loading({
                        container: document.getElementById('ratingWrapper'),
                    });
                }
            }, 1);
        }

        if (this.name != 'occupation-skills') {
            this.loadSkills();
        }

        this.initResource();
    },
    computed: {
        ratingParams() {

            if (this.name == 'occupation-skills' && 
                this.ratingSettings && 
                this.ratingSettings.paramsOccSkill && 
                this.ratingSettings.meaningNotes
            ) {
                const params = Object.keys(this.ratingSettings.paramsOccSkill).map(id => {
                    var param = this.ratingSettings.paramsOccSkill[id];
                    param.id = id;
                    param.description = this.ratingSettings.meaningNotes[id - 1];
                    return param;
                });

                return params;
            } else if (this.ratingSettings && this.ratingSettings.params) {

                const params = Object.keys(this.ratingSettings.params).map(id => {
                    var param = this.ratingSettings.params[id];
                    param.id = id;
                    return param;
                });

                return params;
            }
            return [];
        }
    },
    watch: {
        value(value) {
            this.initResource();
        },
        loading(value) {
            if (value) {
                this.$vs.loading(document.getElementById('ratingWrapper'));
            }
            this.$vs.loading.close(document.getElementById('ratingWrapper'));
        },
        expandAll(value) {
            this.resources.forEach(r => {

                if (r.comment) {
                    this.expanded[r.uid] = value;
                    this.expandedChange++;
                }

            })
        }

    },
    methods: {
        initResource() {
            this.resources = JSON.parse(JSON.stringify(this.value));
        },

        clickExpandHandle(item) {
            this.expanded[item.uid] = this.expanded[item.uid] ? false : true
            this.expandedChange++;
        },

        async loadSkills() {
            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/skills",
                    params: { perpage: 9999, include: ['level'] }
                })
                .then(response => {
                    this.skills = response.data.data;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        getParamDescription(item, param) {
            if (this.name == 'occupation-skills' || this.name == 'self-occupation-skills') {
                const index = (+param.id) - 1;

                return item.levels_description ? item.levels_description[index] : param.label;
            } else {
                return this.getSkillLevelMessageById(item.id, param.id)
            }
        },

        getSkillLevelMessageById(id, levelId) {
            const level = levelId -1

            return data_get(this.skills.find(s => s.id == id), `level.level_${level}`);
        },

        /**
         * Évenement d'une notation
         * @param {string} uid
         */
        inputNotationHandle(uid) {

            let item = this.resources.find(i => i.uid == uid);

            // Traitement de la validation
            if (item.to_validate) {
                item.to_validate = false;
                item.message = this.ratingParams.find(i => i.id == item.level).description;
            }

            // Traitement du multiple
            if (item.is_multiple) {
                this.resources.filter(i => i.id == item.id).map(r => {
                    r.level = item.level;
                })
            }

            this.$emit('input', this.resources)
        },

        inputHandleComment(value, item) {

            this.$set(item, 'comment', value)

            if (item.comment && item.comment.length > 1) {
                this.$emit('input', this.resources)
            }
        }
    }
};
</script>

<style scoped>
    .expand-icon {
        width: 16px;
    }
    .other_level {
        font-weight: bold;
        font-size: 1.7rem;
        top: -5px;
    }
    .other_level_type_0 {
        color: #FF9800;
    }
    .other_level_type_1 {
        color: #4377DF;
    }
    .other_level_type_2 {
        color: #72BB80;
    }
</style>
